import { render, staticRenderFns } from "./RipaPageWrapper.vue?vue&type=template&id=2f90fd91"
import script from "./RipaPageWrapper.vue?vue&type=script&lang=js"
export * from "./RipaPageWrapper.vue?vue&type=script&lang=js"
import style0 from "./RipaPageWrapper.vue?vue&type=style&index=0&id=2f90fd91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports